interface RacequbeLogoProps {
  className?: string;
  variant?: 'default' | 'white';
}

const gradientId = 'logo-gradient';

export function RacequbeLogo({ className = '', variant = 'default' }: RacequbeLogoProps) {

  return (
    <svg
      viewBox="0 0 800 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="raceqube"
    >
      <defs>
        <style>
          {`
            .logo-text {
              font-family: 'Orbitron', sans-serif;
              font-weight: 700;
              font-size: 120px;
              letter-spacing: -4px;
            }
          `}
        </style>
        {variant === 'default' ? (
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: 'hsl(var(--brand-primary))', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: 'hsl(var(--brand-secondary))', stopOpacity: 1 }} />
          </linearGradient>
        ) : null}
      </defs>
      <text
        x="400"
        y="140"
        className="logo-text"
        textAnchor="middle"
        fill={variant === 'white' ? '#FFFFFF' : `url(#${gradientId})`}
      >
        raceqube
      </text>
    </svg>
  );
}
